import {
  Loading
} from 'element-ui'

let loadingObj;
let loadingOptions = {
  text: '努力加载中...',
  spinner: 'el-icon-loading',
  background: 'rgba(51, 50, 50, 0.54)'
}

export default {
  requestList: [],
  addUrl(url) {
    if (url) {
      this.requestList.push(url);
      loadingObj = Loading.service(loadingOptions);
    }
  },
  removeUrl(url) {
    if (url) {
      this.requestList.splice(this.requestList.findIndex(item => item === url), 1)
    }
    //3.当请求列表为空时，更改loading状态
    if (this.requestList.length === 0) {
      loadingObj && loadingObj.close();
    }

  },
  clearLoading() {
    this.requestList = [];
    loadingObj && loadingObj.close();
  }
}
